import debugLog from "@/composables/debugLog";
import { ref } from "vue";

const getAddresses = () => {
  const addresses = ref([]);
  const loadAddress = async (text, retFunc = false) => {
    const searchtext = text
      .toLowerCase()
      .replace("berlin", "")
      .replace("deutschland", "")
      .trim();
    let url =
      "https://api.geoapify.com/v1/geocode/search?apiKey=c663e3ce2d47492fab88ae0a19ac2a7d&lang=de&limit=10&filter=countrycode:de&bias=circle:13.41088392568035,52.47624680384724,25000";
    url = searchtext.length
      ? (url += "&text=" + text)
      : (url += "&text=Berlin");
    debugLog(url);
    fetch(url)
      .then(response => response.json())
      .then((data) => {
        addresses.value = parseGeoLocs(data.features);
        if (retFunc) retFunc();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return { loadAddress, addresses };
};

const parseGeoLocs = (locs) => {
  debugLog(locs);
  let addresses = {};
  locs.forEach((pl, i) => {
    let props = pl.properties;
    // Remove if generic Berlin Result
    if (props.formatted == "Berlin, Deutschland") return;
    // Remove if already has results, and 0 confidence on result
    if (Object.keys(addresses).length && props.rank.confidence == 0 && props.result_type !== 'suburb') return;
    // Remove if address not in Berlin
    if (props.city !== "Berlin") return;
    // Remove if no bbox
    if(!pl.bbox) return;

    // Remove if amenity , TESTING 10.09.2024
    if( props.result_type == "amenity") return;

    // Format Address name
    let addressName = props.formatted
      .replace(" Berlin, Deutschland", "")
      .replace("BE, Deutschland", "")
      .replace("Berlin, ","")
      .trim();
    if (addressName.charAt(addressName.length - 1) == ",")
      addressName = addressName.slice(0, -1);

    // ADD NEIGHBORHOOD IF STREET
    if (
      (props.result_type == "street" ||
        props.result_type == "building" ||
        props.result_type == "amenity") &&
      props.suburb
    ) {
      addressName += ", " + props.suburb;
    }

    // ADD BERLIN IF SUBURB OR DISTRICT
    if (
      (props.result_type == "district" || props.result_type == "suburb") &&
      addressName.indexOf("Berlin") == -1
    ) {
      addressName = "Berlin-" + addressName;
    }

    if(addressName.indexOf('Ei-') >= 0 && props?.address_line2?.indexOf('Berlin') >= 0){
      addressName = props.address_line2;
    }

    // ADD DISTRICT IF PLZ
    if (props.result_type == "postcode") {
      if (props.district && props.postcode) {
        addressName = props.postcode + " " + props.district;
      } else {
        addressName += " Berlin";
      }
    }



    let addressDist = 0;
    // Get Distance if there's a bounding box
    if (pl.bbox) {
      addressDist = Math.ceil(
        getDistanceInKm(pl.bbox[1], pl.bbox[0], pl.bbox[3], pl.bbox[2])
      );
    } else {
      addressDist = 0;
    }

    // Fix PLZs beign too small
    if (props.result_type == "postcode") {
      addressDist += 1;
    }

    // Filter out PLZs with oversized bounding boxes
    if (
      addresses.hasOwnProperty(addressName) &&
      props.result_type == "postcode" &&
      addresses[addressName].result_type == "postcode" &&
      addressDist > addresses[addressName].dist
    ) {
      return;
    }

    addresses[addressName] = {
      coords: pl.geometry.coordinates[0] + "," + pl.geometry.coordinates[1],
      dist: addressDist,
      name: addressName,
      bbox: pl.bbox,
      result_type: props.result_type,
    };
  });

  
  addresses = Object.keys(addresses).map((key) => {
    return addresses[key];
  });

  let postcodedistance = 100000;
  addresses.forEach(address => {
    if(address.result_type !== "postcode") return;
    if(address.dist < postcodedistance ){
      postcodedistance = address.dist;
    }
  })

  addresses = addresses.filter(address => {  
    if(address.result_type !== "postcode"){
      return true;
    }
    if(address.dist !== postcodedistance){
      return false;
    }else{
      return true;
    }
  })
  
  debugLog(addresses);
  return addresses;
};

const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};

export default getAddresses;
